export const CLINICAL_DEFAULT_REPORT_TEE_RESPONSE = [
    {
        "code": "RIS-X-1256",
        "description": "Referto Radio 1",
        "id": "b34d0764-112f-44c6-a134-78e1ef9152fd",
        "modalities": [
            {
                "description": "RX",
                "id": "9d03e477-9ec6-450d-9e17-0d8bfe806c83",
                "isMandatoryEquipmentChange": false
            }
        ],
        "referringPhysician": {
            "description": "Utente 1",
            "employeeSerialNumber": null,
            "id": "7453b140-1124-4e5c-b7d0-6d7504aae9bd"
        },
        "standardModalities": null,
        "texts": {
            "Conclusion": "<div><p>CONCLUSION 1</p></div>",
            "Execution": "<div><p>EXECUTION 1</p></div>",
            "Finding": "<div><p>FINDINGS 1</p></div>"
        }
    },
    {
        "code": "RIS-X-56",
        "description": "Referto Radio 2",
        "id": "d0bd2300-63ce-43ff-a5ce-c9798d1ccb7b",
        "modalities": [
            {
                "description": "RX",
                "id": "6dd9d9bb-791d-44d4-bf2d-b3670a40633d",
                "isMandatoryEquipmentChange": false
            }
        ],
        "referringPhysician": {
            "description": "Utente 1",
            "employeeSerialNumber": null,
            "id": "e4d07309-0573-4dea-9f93-17c8ad129e83"
        },
        "standardModalities": null,
        "texts": {
            "Conclusion": "<div><p>CONCLUSION 2</p></div>",
            "Execution": "<div><p>EXECUTION 2</p></div>",
            "Finding": "<div><p>FINDINGS 2</p></div>"
        }
    }
];

export const CLINICAL_DEFAULT_REPORT_TTE_RESPONSE = [
    {
        "code": "RIS-X-1256",
        "description": "Referto Radio 1",
        "id": "b34d0764-112f-44c6-a134-78e1ef9152fd",
        "modalities": [
            {
                "description": "RX",
                "id": "9d03e477-9ec6-450d-9e17-0d8bfe806c83",
                "isMandatoryEquipmentChange": false
            }
        ],
        "referringPhysician": {
            "description": "Utente 1",
            "employeeSerialNumber": null,
            "id": "7453b140-1124-4e5c-b7d0-6d7504aae9bd"
        },
        "standardModalities": null,
        "texts": {
            "Conclusion": "<DIV STYLE=\"text-align:Left;line-height: 1direction:ltr;font-family:Verdana;font-style:normal;font-weight:normal;font-size:12px;color:#222;white-space:pre-wrap;\"><P><SPAN>prova c1</SPAN></P><P><SPAN STYLE=\"text-decoration:underline;\">prova c2</SPAN></P><DIV STYLE=\"line-height: 1;\"><P><SPAN STYLE=\"text-decoration:underline;\">Reperti di normalità.</SPAN></P><P /></DIV><P><SPAN>conclusione del referto D2</SPAN></P></DIV>",
            "Execution": "<DIV STYLE=\"text-align:Left;line-height: 1direction:ltr;font-family:Verdana;font-style:normal;font-weight:normal;font-size:12px;color:#222;white-space:pre-wrap;\"><P><SPAN>Al a carico delle pareti del rene con la DATM 23 s fine. Non appaiono evidenti i due amenorrea iniziale. 0 parailare con il disco dell'esame con un CA</SPAN></P></DIV>",
            "Finding": "<DIV STYLE=\"text-align:Left;line-height: 1;direction:ltr;font-family:Verdana;font-style:normal;font-weight:normal;font-size:12px;color:#222;white-space:pre-wrap;\"><DIV><P><SPAN>Metameri vertebrali in asse, di segnale regolare.  </SPAN></P><P><SPAN>Note di artrosi somatica e interapofisaria.  </SPAN></P><P><SPAN>Canale rachideo di calibro nei limiti.  </SPAN></P><P><SPAN>Regolare il midollo dorsale inferiore e il cono midollare.  </SPAN></P><P><SPAN>Contenuti posteriormente gli ultimi   dischi dorsali e i primi due lombari.</SPAN></P><P><SPAN>Test</SPAN></P><P /></DIV></DIV>"
        }
    },
    {
        "code": "RIS-X-56",
        "description": "Referto Radio 2",
        "id": "d0bd2300-63ce-43ff-a5ce-c9798d1ccb7b",
        "modalities": [
            {
                "description": "RX",
                "id": "6dd9d9bb-791d-44d4-bf2d-b3670a40633d",
                "isMandatoryEquipmentChange": false
            }
        ],
        "referringPhysician": {
            "description": "Utente 1",
            "employeeSerialNumber": null,
            "id": "e4d07309-0573-4dea-9f93-17c8ad129e83"
        },
        "standardModalities": null,
        "texts": {
            "Conclusion": "<DIV STYLE=\"text-align:Left;line-height: 1;direction:ltr;font-family:Verdana;font-style:normal;font-weight:normal;font-size:12px;color:#222;white-space:pre-wrap;\"><P><SPAN>Esame confrontato con il precedente in visione del </SPAN></P><P><SPAN /></P><P><SPAN>Rettilineizzazione della fisiologica lordosi.</SPAN></P><P><SPAN>Antero-listesi di I° di L2.</SPAN></P><P><SPAN>Non cedimenti somatici.</SPAN></P><P><SPAN>Piccola ernia intraspongiosa a carico di L3.</SPAN></P><P><SPAN>L1-L2: protrusione posteriore discale ad impegno durale ventrale.</SPAN></P><P><SPAN>L2-L3: discopatia degenerativa con grossolana ernia estrusa paramediana e foraminale sn in migrazione craniale e a conflitto radicolare omolaterale.</SPAN></P><P><SPAN>L3-L4: discopatia degenerativa con bulging posteriore ad ampio raggio.</SPAN></P><P><SPAN>L4-L5: bulging posteriore ad impegno durale ventrale.</SPAN></P><P><SPAN>L5-S1: protrusione discale posteriore pre ed intraforaminale sinistra in conflitto radicolare S1 omolaterale. </SPAN></P><P><SPAN>Nella norma il segnale del midollo dorsale inferiore visibile e il cono midollare.</SPAN></P><P><SPAN>Non masse in sede paravertebrale.</SPAN></P><P><SPAN /></P></DIV>",
            "Execution": "<DIV STYLE=\"text-align:Left;line-height: 1;direction:ltr;font-family:Verdana;font-style:normal;font-weight:normal;font-size:12px;color:#222;white-space:pre-wrap;\"><DIV STYLE=\"color:#222;\"><DIV><DIV STYLE=\"color:#222;\"><DIV STYLE=\"color:#222;\"><P><SPAN STYLE=\"color:#222;\">Cambiaot 2ssss</SPAN></P></DIV></DIV></DIV></DIV></DIV>",
            "Finding": ""
        }
    }
];

export const CLINICAL_DEFAULT_REPORT_SINGLE_GROUP_RESPONSE = [
    {
        "code": "RIS-X-1256",
        "description": "Frase predefinita Cardio 1",
        "id": "b34d0764-112f-44c6-a134-78e1ef9152fd",
        "modalities": [
            {
                "description": "RX",
                "id": "9d03e477-9ec6-450d-9e17-0d8bfe806c83",
                "isMandatoryEquipmentChange": false
            }
        ],
        "referringPhysician": {
            "description": "Utente 1",
            "employeeSerialNumber": null,
            "id": "7453b140-1124-4e5c-b7d0-6d7504aae9bd"
        },
        "standardModalities": null,
        "texts": {
            "predefinedText": "<DIV STYLE=\"text-align:Left;line-height: 1direction:ltr;font-family:Verdana;font-style:normal;font-weight:normal;font-size:12px;color:#222;white-space:pre-wrap;\"><P><SPAN>prova c1</SPAN></P><P><SPAN STYLE=\"text-decoration:underline;\">prova c2</SPAN></P><DIV STYLE=\"line-height: 1;\"><P><SPAN STYLE=\"text-decoration:underline;\">Reperti di normalità.</SPAN></P><P /></DIV><P><SPAN>conclusione del referto D2</SPAN></P></DIV>",
        }
    },
    {
        "code": "RIS-X-56",
        "description": "Frase predefinita Cardio 2",
        "id": "d0bd2300-63ce-43ff-a5ce-c9798d1ccb7b",
        "modalities": [
            {
                "description": "RX",
                "id": "6dd9d9bb-791d-44d4-bf2d-b3670a40633d",
                "isMandatoryEquipmentChange": false
            }
        ],
        "referringPhysician": {
            "description": "Utente 1",
            "employeeSerialNumber": null,
            "id": "e4d07309-0573-4dea-9f93-17c8ad129e83"
        },
        "standardModalities": null,
        "texts": {
            "predefinedText": "<DIV STYLE=\"text-align:Left;line-height: 1;direction:ltr;font-family:Verdana;font-style:normal;font-weight:normal;font-size:12px;color:#222;white-space:pre-wrap;\"><P><SPAN>Esame confrontato con il precedente in visione del </SPAN></P><P><SPAN /></P><P><SPAN>Rettilineizzazione della fisiologica lordosi.</SPAN></P><P><SPAN>Antero-listesi di I° di L2.</SPAN></P><P><SPAN>Non cedimenti somatici.</SPAN></P><P><SPAN>Piccola ernia intraspongiosa a carico di L3.</SPAN></P><P><SPAN>L1-L2: protrusione posteriore discale ad impegno durale ventrale.</SPAN></P><P><SPAN>L2-L3: discopatia degenerativa con grossolana ernia estrusa paramediana e foraminale sn in migrazione craniale e a conflitto radicolare omolaterale.</SPAN></P><P><SPAN>L3-L4: discopatia degenerativa con bulging posteriore ad ampio raggio.</SPAN></P><P><SPAN>L4-L5: bulging posteriore ad impegno durale ventrale.</SPAN></P><P><SPAN>L5-S1: protrusione discale posteriore pre ed intraforaminale sinistra in conflitto radicolare S1 omolaterale. </SPAN></P><P><SPAN>Nella norma il segnale del midollo dorsale inferiore visibile e il cono midollare.</SPAN></P><P><SPAN>Non masse in sede paravertebrale.</SPAN></P><P><SPAN /></P></DIV>",
        }
    }
];
